/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import { ACCOUNT_TYPES } from '../../model';

const AccountTypeDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown options={ACCOUNT_TYPES} placeholder="Choose account type" {...props} />;
};

export default AccountTypeDropdown;
